export const WA_NOTIFICATION_SOUND_MAX_BYTES = 5 * 1024 * 1024;
/** Integrations routes for custom WhatsApp Web notification audio (S3-backed). */
export const WA_NOTIFICATION_SOUND_API_BASE = "/integrations/users/self/wa-notification-sound";
export const WPPH = "web.whatsapp.com";
export const WPP = `https://${WPPH}`;
export const MOCK_CHAT = "https://mock-messaging.tuviz.io";
export const SFDCH = ".salesforce.com";
export const SFSITE = ".my.site.com";
export const SPECIFIC = ["www.customer360psa.com"];
export const SLFTH = "app.salesloft.com";
export const MSDYNAMICSH = ".dynamics.com";
export const OUTREACHH = ".outreach.io";
export const HUBSPOTH = ".hubspot.com";
export const SFDCLH = "force.com";
export const APEX_LINK = "https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3A00000G0y1gUAB";
export const PREFIX_SF_TUVIS_SUBJECT = "[Tuvis]";
export const IMESSAGE = "IMESSAGE";
export const PREFIX_SF_WHATSLLY_SUBJECT = "[Whatslly] ";

export const MSD_APPSOURCE_LINK = "https://appsource.microsoft.com/en-us/product/dynamics-365/tuvisltd1651085613452.tuvis_dyn365";
export const BOOK_A_DEMO_PAGE_LINK = "https://tuvis.com/book-a-demo";
export const FORCE_OPEN_IN_BROWSER = "___TuvisForceOpenInBrowser___";
export const EMAIL_PREVIEW_URL_SUFFIX = "#___TuvisEmailPreviewDataUri___";
export const FILES_HOST = "https://assets.whatslly.com/product";
export const ICON = `${FILES_HOST}/img/tuvis/tuvis-17.png`;
export const CHAT_NOW_SVG_CONTENT = `<svg width="200" height="200" viewBox="12.979562759399414 30.574216842651367 219.652982711792 135.16350173950195" xmlns="http://www.w3.org/2000/svg" version="1.1"><defs><style>
      .cls-2{fill:#82c0f7}
    </style></defs><path class="cls-2" d="m140.99 110.61 32.5-49.49a19.06 19.06 0 1 0-31.8-20.95l-24.31 36.94 23.61 33.5zM47.65 74.97a19.06 19.06 0 0 0-31.18 22.02l36.76 52.11a37.61 37.61 0 0 0 53.74 9.15c-1.16-1.34-59.32-83.28-59.32-83.28z" id="svg_2"/><path class="cls-2" d="M140.4 164.74a37.53 37.53 0 0 1-31.22-16.64L72.44 95.99a19.06 19.06 0 0 1 31.15-22.02l36.81 52.23 57.24-87.03a19.06 19.06 0 1 1 31.85 20.95l-57.67 87.69a37.5 37.5 0 0 1-31.42 16.93z" id="svg_3"/></svg>
`;
export const LOADER_IMG = `${FILES_HOST}/img/tuvis/loader.svg`;
export const INTERVAL_OF_VERSIONS = 3;
export const WHATSLLY_LOGO_CIRCLE_URL = "https://assets.whatslly.com/product/img/tuvis/tuvis-circle-128.png";
export const WHATSLLY_LOGO_VIS_URL = "https://assets.whatslly.com/product/img/tuvis/tuvis-vis-128.png";
export const GET_VALID_BROWSER_VERSION_SUFFIX_URL = `/integrations/api/get-valid-browser-version`;
export const TERMS_CONDITIONS_TUVIS_URL = `https://tuvis.com/terms-conditions/`;
export const PRIVACY_POLICY_TUVIS_URL = `https://tuvis.com/privacy-policy/`;

export const OPPORTUNITIES_PAGE_SIZE = 30;
export const CASES_PAGE_SIZE = 10;
export const ACTIVITIES_PAGE_SIZE = 10;
export const RELATE_OPP_FIELD_NAME = "whatsllySfdcRelatedOpp";
export const DATE_AND_TIME_FIELDS_API_NAMES = ["StartDateTime", "EndDateTime", "IsAllDayEvent", "ActivityDateTime"];

export const FONTS = [
  {
    name: "Galano Grotesque",
    fontStyle: "normal",
    fontWeight: 700,
    woffPath: "/fonts/GalanoGrotesqueBold/GalanoGrotesque-Bold.woff",
    woff2Path: "/fonts/GalanoGrotesqueBold/GalanoGrotesque-Bold.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "italic",
    fontWeight: 700,
    woffPath: "/fonts/GalanoGrotesqueBoldItalic/GalanoGrotesque-BoldItalic.woff",
    woff2Path: "/fonts/GalanoGrotesqueBoldItalic/GalanoGrotesque-BoldItalic.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "normal",
    fontWeight: 600,
    woffPath: "/fonts/GalanoGrotesqueSemiBold/GalanoGrotesque-SemiBold.woff",
    woff2Path: "/fonts/GalanoGrotesqueSemiBold/GalanoGrotesque-SemiBold.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "italic",
    fontWeight: 600,
    woffPath: "/fonts/GalanoGrotesqueSemiBoldItalic/GalanoGrotesque-SemiBoldItalic.woff",
    woff2Path: "/fonts/GalanoGrotesqueSemiBoldItalic/GalanoGrotesque-SemiBoldItalic.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "normal",
    fontWeight: 500,
    woffPath: "/fonts/GalanoGrotesqueMedium/GalanoGrotesque-Medium.woff",
    woff2Path: "/fonts/GalanoGrotesqueMedium/GalanoGrotesque-Medium.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "italic",
    fontWeight: 500,
    woffPath: "/fonts/GalanoGrotesqueMediumItalic/GalanoGrotesque-MediumItalic.woff",
    woff2Path: "/fonts/GalanoGrotesqueMediumItalic/GalanoGrotesque-MediumItalic.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "normal",
    fontWeight: 400,
    woffPath: "/fonts/GalanoGrotesqueRegular/GalanoGrotesque-Regular.woff",
    woff2Path: "/fonts/GalanoGrotesqueRegular/GalanoGrotesque-Regular.woff2",
  },
  {
    name: "Galano Grotesque",
    fontStyle: "italic",
    fontWeight: 400,
    woffPath: "/fonts/GalanoGrotesqueRegularItalic/GalanoGrotesque-RegularItalic.woff",
    woff2Path: "/fonts/GalanoGrotesqueRegularItalic/GalanoGrotesque-RegularItalic.woff2",
  },
];
